import { render } from "./DefaultLayout.vue?vue&type=template&id=4e78e172"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/wavemobile.de/wavemobile/FE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__